import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import UsersMain from '../../components/users/UsersMain'
import Footer from '../../components/common/Footer'
export default function UserPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <UsersMain/>
            <Footer/>
        </>
    )
}